import { useMountEffect } from "@react-hookz/web";
import { useLenis } from "lenis/react";

export const useScrollResetOnMount = () => {
  const lenis = useLenis();

  useMountEffect(() => {
    lenis?.scrollTo(0, { immediate: true });
  });
};
